<!-- 嵌入式-产品点位数据 -->
<template>
  <el-card>
    <div class="toolbar">
      <div class="former">
        <el-select
          v-model="queryFormBind.dciProductModelName"
          clearable
          placeholder="选择产品型号"
          style="width: 250px"
        >
          <el-option
            v-for="ele in modelList"
            :key="ele"
            :label="ele"
            :value="ele"
          >
          </el-option>
          <!-- <el-option
            v-for="ele in modelList"
            :key="ele.ID"
            :label="ele.NameNumber"
            :value="ele.ID"
          >
          </el-option> -->
        </el-select>
        &nbsp;
        <el-input
          v-model.trim="queryFormBind.key"
          placeholder="点位名称或客户名称或MN或产品SN"
          @keyup.enter.native="onSubmitQuery"
          style="width: 220px"
        ></el-input>
        &nbsp;
        <!-- <el-input
          v-model.trim="queryFormBind.client"
          placeholder="请输入合同编号或客户名称"
          @keyup.enter.native="onSubmitQuery"
          style="width: 220px"
        ></el-input>
        &nbsp; -->
        <!-- <select2
          labelName="SN"
          v-model="queryFormBind.ID"
          :url="productUrl"
          :urlParams="{
            where: {},
          }"
          placeholder="请选择产品SN"
          no-data-text="无产品"
          q="SN:like"
          :qinwhere="true"
          :queryOne="false"
        ></select2> 
        &nbsp;-->
        <el-select
          v-model="queryFormBind.ContractNos"
          multiple
          filterable
          :clearable="true"
          default-first-option
          placeholder="请选择合同编号"
        >
          <el-option
            v-for="(contractNo, index) in contractNoList"
            :key="index"
            :label="contractNo"
            :value="contractNo"
          ></el-option>
        </el-select>
        &nbsp;
        <el-select
          v-model="queryFormBind.Tags"
          multiple
          filterable
          :clearable="true"
          default-first-option
          placeholder="请选择标签"
        >
          <el-option
            v-for="(tag, index) in tagList"
            :key="index"
            :label="tag"
            :value="tag"
          ></el-option>
        </el-select>
        &nbsp;
        <el-select
          v-model="queryFormBind.heartbeat"
          clearable
          placeholder="在线状态"
          style="width: 100px"
        >
          <el-option label="在线" :value="1"></el-option>
          <el-option label="离线" :value="0"></el-option>
        </el-select>
        &nbsp;
        <el-select
          v-model="queryFormBind.Status"
          clearable
          placeholder="产品状态"
          style="width: 100px"
        >
          <el-option label="已出库" :value="2"></el-option>
          <el-option label="已激活" :value="4"></el-option>
          <el-option label="维修中" :value="7"></el-option>
          <el-option label="已停用" :value="8"></el-option>
        </el-select>
        &nbsp;
        <el-button
          size="small"
          @click="onSubmitQuery"
          title="搜索"
          type="primary"
        >
          <i class="fas fa-search"></i>
        </el-button>
      </div>
    </div>

    <div id="app">
      <el-table
        :data="stationList"
        v-loading="loading"
        style="margin-top: -15px"
      >
        <el-table-column
          type="index"
          :index="15 * (currentPage - 1) + 1"
          width="52"
        ></el-table-column>
        <el-table-column label="点位名称/定位地址">
          <template slot-scope="scope">
            <div>
              <span style="font-weight: bolder">
                {{ scope.row.DciStation.Name }}</span
              >
            </div>
            <div>
              <span style="color: #909399">{{
                scope.row.DciStation.Area
              }}</span>
              <el-tooltip
                content="Top center"
                placement="top"
                effect="light"
                v-if="
                  scope.row.DciStation && scope.row.DciStation.AreaDesc !== ''
                "
              >
                <div slot="content">{{ scope.row.DciStation.AreaDesc }}</div>
                <i
                  class="el-icon-info"
                  style="color: #409eff; cursor: pointer"
                ></i>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="DciStation.MN"
          label="MN"
          width="160"
        ></el-table-column>
        <el-table-column
          prop="DciProductModel.NameNumber"
          label="产品型号名称"
          width="170"
        ></el-table-column>
        <el-table-column prop="SN" label="产品SN" width="170">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.SN">
              {{ scope.row.SN }}
            </el-tag>
            <el-tag type="success" v-if="scope.row.Remark">
              {{ scope.row.Remark }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="Tags" label="标签" width="80">
          <template scope="scope">
            <div v-if="scope.row.DciStation">
              <span v-for="tag in scope.row.DciStation.Tags" :key="tag">
                <el-tag type="success">{{ tag }}</el-tag>
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column width="50" align="center" label="在线状态">
          <template slot-scope="scope">
            <!-- <span v-if="scope.row.HeartBeat === true" title="在线">
              <div class="circle-h bg-success"></div>
            </span>
            <span v-else title="离线">
              <div class="circle-h bg-danger"></div>
            </span> -->
            <el-tooltip content="Top center" placement="top" effect="light">
              <div slot="content" v-if="scope.row.HeartBeat === true">
                <div v-if="scope.row.HeartBeatAt">
                  在线:{{ scope.row.HeartBeatAt }}
                </div>
                <div v-else>在线</div>
              </div>
              <div slot="content" v-else>
                <div v-if="scope.row.HeartBeatAt">
                  离线:{{ scope.row.HeartBeatAt }}
                </div>
                <div v-else>离线</div>
              </div>
              <i
                class="fa fa-wifi fa-lg"
                style="color: #92c655; cursor: pointer"
                v-if="scope.row.HeartBeat === true"
              ></i>
              <i
                class="fa fa-wifi fa-lg"
                style="color: #f0615e; cursor: pointer"
                v-else
              ></i>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column width="50" align="center" label="报警状态">
          <template slot-scope="scope">
            <!--<span
              v-if="
                scope.row.DciStation && scope.row.DciStation.IsAlarmed === true
              "
              title="有报警问题"
            >
              <div class="circle-h bg-danger"></div>
            </span>
            <span v-else title="无报警问题">
              <div class="circle-h bg-success"></div>
            </span> -->
            <el-tooltip content="Top center" placement="top" effect="light">
              <div
                slot="content"
                v-if="
                  scope.row.DciStation &&
                  scope.row.DciStation.IsAlarmed === true
                "
              >
                有报警问题
              </div>
              <div slot="content" v-else>无报警问题</div>
              <i
                class="fa fa-bell fa-lg"
                style="color: #f0615e; cursor: pointer"
                v-if="
                  scope.row.DciStation &&
                  scope.row.DciStation.IsAlarmed === true
                "
              ></i>
              <i
                class="fa fa-bell fa-lg"
                style="color: #92c655; cursor: pointer"
                v-else
              ></i>
            </el-tooltip>
          </template>
        </el-table-column>

        <el-table-column width="50" align="center" label="实施信息">
          <template slot-scope="scope">
            <el-tooltip content="Top center" placement="top" effect="light">
              <div
                slot="content"
                v-if="scope.row.ImplementationStatus === 1"
              >
                已实施
              </div>
              <div
                slot="content"
                v-else-if="scope.row.ImplementationStatus === 0"
              >
                未实施
              </div>
              <div
                slot="content"
                v-else
              >
                不可实施
              </div>
              <i
                class="fa fa-screwdriver-wrench fa-lg"
                style="color: #92c655; cursor: pointer"
                v-if="scope.row.ImplementationStatus === 1"
                @click="onImplementationItem(scope.row)"
              ></i>
              <i
                class="fa fa-screwdriver-wrench fa-lg"
                style="color: #409eff; cursor: pointer"
                v-else-if="scope.row.ImplementationStatus === 0"
                @click="onImplementationItem(scope.row)"
              ></i>
              <i
                class="fa fa-screwdriver-wrench fa-lg"
                style="color: #c0c4cc; cursor: pointer"
                v-else
              ></i>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="StatusName" label="产品状态" width="80">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.StatusName === '已激活'" type="success">
              {{ scope.row.StatusName }}
            </el-tag>
            <el-tag v-else-if="scope.row.StatusName === '维修中'" type="danger">
              {{ scope.row.StatusName }}
            </el-tag>
            <el-tag v-else-if="scope.row.StatusName === '已停用'" type="info">
              {{ scope.row.StatusName }}
            </el-tag>
            <el-tag v-else>
              {{ scope.row.StatusName }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="QualityEndAt" label="质保期" width="90">
          <template slot-scope="scope">
            <div
              v-if="
                scope.row.QualityEndAt &&
                new Date(scope.row.QualityEndAt).getTime() <=
                  new Date(new Date()).getTime()
              "
              style="color: red"
            >
              {{ $sys.dateFormat(scope.row.QualityEndAt, "Y-m-d") }}
            </div>
            <div v-else-if="scope.row.QualityEndAt">
              {{ $sys.dateFormat(scope.row.QualityEndAt, "Y-m-d") }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="220">
          <template scope="scope">
            <div class="text-nowrap">
              <el-button
                @click="showMessage(scope.row)"
                size="small"
                title="状态数据"
                style="width: 33px"
              >
                <i class="fas fa-list-ol"></i>
              </el-button>
              <el-button
                type="primary"
                size="small"
                title="点位详情"
                @click="onDetailItem(scope.row)"
                style="width: 33px"
              >
                <i class="fas fa-eye"></i>
              </el-button>
              <el-button
                type="primary"
                title="远程控制"
                @click="showControl(scope.row)"
                style="width: 33px"
                v-permission="'dci_communication-*'"
              >
                <i class="fas fa-exchange-alt"></i>
              </el-button>
              <!-- <el-button
                type="warning"
                title="动态密码"
                @click="onPasswordClick(scope.row)"
                style="width: 33px"
                v-permission="'dci_communication-*'"
              >
                <i class="fa fa-key"></i>
              </el-button> -->
              <el-button
                type="danger"
                title="报警详情"
                @click="showAlarm(scope.row)"
                style="width: 33px"
              >
                <i class="fa fa-bell fa-lg"></i>
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="clearfix mar-top">
      <el-pagination
        class="pull-right"
        @current-change="changePage"
        layout="total, prev, pager, next"
        :total="totalItem"
        :current-page="currentPage"
        :page-size="15"
      >
      </el-pagination>
    </div>

    <detail-form
      v-model="item"
      :visible.sync="stationVisible"
      @form:saved="getStationList"
    />
    
    <!-- <implementation-form
      v-model="item"
      :visible.sync="implementationVisible"
      @form:saved="getStationList"
    /> -->
    <implementation-index
      v-model="item"
      :visible.sync="implementationVisible"
      @form:done="getStationList"
    />
  </el-card>
</template>
<script>
import DetailForm from "./detail.vue";
// import ImplementationForm from "./implementationForm.vue";
import ImplementationIndex from "./implementationIndex.vue";

export default {
  components: {
    DetailForm,
    // ImplementationForm,
    ImplementationIndex,
  },
  data() {
    return {
      loading: false,
      stationVisible: false,
      implementationVisible: false,
      item: {},
      modelList: [], //产品型号
      queryFormBind: {
        key: "",
        // client: "",
        dciProductModelName: "",
        // ID: "",
        Tags: [],
        ContractNos: [],
        heartbeat: "",
        Status: "",
      },
      // productUrl: "",
      modelActive: "",
      stationList: [],
      currentPage: 1,
      totalItem: 1,
      tagList: [],
      contractNoList: [],
    };
  },
  mounted() {
    this.getModelList();
    this.getTagList();
    this.getContractNoList();
    this.getStationList();
  },
  methods: {
    //获取标签
    getTagList() {
      this.$axios
        .get("dci/station/tag")
        .then((response) => {
          this.tagList = response.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    //获取合同编号
    getContractNoList() {
      this.$axios
        .get("dci/station/contractNo")
        .then((response) => {
          this.contractNoList = response.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    //获取产品型号名称列表
    getModelList() {
      this.$axios.get("dci/model/product/name/list").then(
        (response) => {
          this.modelList = response.data;
          // this.modelList.push({
          //   ID: 0,
          //   NameNumber: "其它类型",
          // });
        },
        (response) => {
          this.$sys.alarmResponse(response);
        }
      );
    },
    // 获取站点数据列表
    getStationList() {
      this.loading = true;
      this.$axios
        .get("dci/station", {
          params: {
            where: {
              // DciProductModelID: this.queryFormBind.DciProductModelID,
              Status: this.queryFormBind.Status,
              // ID: this.queryFormBind.ID,
            },
            key: this.queryFormBind.key,
            // client: this.queryFormBind.client,
            dciProductModelName: this.queryFormBind.dciProductModelName,
            heartbeat: this.queryFormBind.heartbeat,
            Tags: this.queryFormBind.Tags,
            ContractNos: this.queryFormBind.ContractNos,
            page: this.currentPage,
            with: ["DciStation", "DciProductModel", "DciPvProductVersion", "Implementations"],
            order: ["-sn"],
          },
        })
        .then((response) => {
          this.stationList = response.data.data;
          this.totalItem = response.data.total;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //站点详情
    onDetailItem(row) {
      this.item = row;
      this.stationVisible = true;
    },
    //远程控制
    showControl(row) {
      this.$router.push(
        `/dci/manage?sn=${row.SN}&id=${row.ID}&name=${row.DciStation.Name}`
      );
    },
    //动态密码
    onPasswordClick(row) {},
    //报警信息
    showAlarm(row) {
      this.$router.push(`/application/alarm?sn=${row.SN}&id=${row.ID}`);
    },
    //状态数据
    showMessage(row) {
      if (row.DciStation) {
        this.$router.push(`/application/message/${row.DciStation.ID}`);
      }
    },
    //实施信息
    onImplementationItem(row) {
      this.item = row;
      this.implementationVisible = true;
    },
    // 提交搜索
    onSubmitQuery() {
      // this.queryForm = { ...this.queryForm, ...this.queryFormBind };
      // this.queryForm.DciProductModelID = parseInt(this.modelActive, 2);
      // changePage会监测页码的变化，自动调用dispatch
      if (this.currentPage !== 1) {
        this.currentPage = 1;
      } else {
        this.getStationList();
      }
    },
    // 翻页
    changePage(page) {
      this.currentPage = page;
      this.getStationList();
    },
  },
};
</script>
<style scoped lang="scss">
.circle-h {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-left: calc(50% - 10px);
}
.el-table thead {
  color: #909399;
  font-weight: 500;
  font-size: larger;
}
#app {
  width: 100%;
  height: 100%;
  .el-table {
    // 看这里！！！！！！！！！！！！！！！！！！！！！！！！！！！！
    // 深度选择器，去除默认的padding
    /deep/ th {
      padding: 0;
      font-size: larger;
    }
  }
}
</style>
